import type React from 'react';
import { useState } from 'react';
import Question from '../../../general/Question/Question';
import Translation from '../../../general/Translation/Translation';
import Section from '../../../general/Section/Section';
import type { FaqState } from '../../../../ssr/src/Outlet/ShoppingCart/ShoppingCartSchema';

export interface FaqProps {
  faqs: FaqState['faqItems'];
}

const FAQ: React.FC<FaqProps> = ({ faqs }) => {
  const [visibility, setVisibility] = useState<boolean[]>(
    faqs.map(() => false),
  );

  const toggleFAQ = (key: number): void => {
    const newVisibility = [...visibility];
    newVisibility[key] = !newVisibility[key];
    setVisibility(newVisibility);
  };

  return (
    <Section
      isXl
      wrapperMd
      hasBorderTop
    >
      <h2 className="h3">
        <Translation
          pageString="checkout"
          stringId="faq-title"
        />
      </h2>
      {faqs.map((faq, i) => (
        <Question
          key={faq.question}
          question={faq.question}
          answer={faq.answer}
          onToggle={() => toggleFAQ(i)}
          isOpen={visibility[i] ?? false}
        />
      ))}
    </Section>
  );
};

export default FAQ;
